import { formatDate } from '@btime/helpers'
import { propEq } from 'ramda'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { ACTIONS } from '../../_constants/actions'
import { genFormattedColumn, useRowActionsColumn } from '../../../../components/tables/Table'
import { sessionsClient } from '../../../../utils/apollo/api'
import { useOpenShowWebhookModal } from '../../../../utils/routes/modals/modalsActions'
import { useWebhooks } from '../_load/WebhookLoader'
import { useRowsActions } from './_actions/rowsActions'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import Link from '../../../../components/actions/Link'
import SwitchDisabled from '../../../../components/helpers/disabled/SwitchDisabled'
import Text from '../../../../packages/kiti/components/presentation/Text'

const WebhookTable = () => {
  const { t } = useTranslation(['webhook', 'common'])
  const webhooks = useWebhooks()
  const canEdit = useSessionPermission('editPublicToken')

  const openDetails = useOpenShowWebhookModal()

  const columns = [
    {
      label: t('webhook:name'),
      dataIndex: 'name',
      sortIndex: false,
      flex: 5,
      render: (name, record) => (
        <Link onClick={() => openDetails(record.id)}>
          <Text size="xxsmall">{ACTIONS.find(propEq('id', record.action))?.name}</Text>
          <Text bold>{name}</Text>
        </Link>
      )
    },

    {
      label: t('webhook:availableUses'),
      dataIndex: 'amountLeft',
      sortIndex: false,
      flex: 2
    },

    {
      label: t('common:createdAt'),
      dataIndex: 'insertedAt',
      sortIndex: 'INSERTED_AT',
      flex: 2,
      render: genFormattedColumn(formatDate('DD/MM/YYYY HH:mm'))
    },

    {
      label: t('webhook:enabled'),
      dataIndex: 'enabled',
      sortIndex: false,
      flex: 1,
      render: (_, record) => (
        <SwitchDisabled
          client={sessionsClient}
          entity="PublicToken"
          record={record}
          size={'small'}
          disabled={!canEdit}
        />
      )
    },

    {
      label: t('common:actions'),
      flex: 1,
      render: useRowActionsColumn(useRowsActions)
    }
  ]

  return <DataTable rowKey="id" columns={columns} size="medium" data={webhooks} inPanel />
}

export default WebhookTable
